import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';
import { router } from './routes';
import { loggingOptions } from './middleware/logging';
import {
    getDynamicImport, getHashMap, stylesUrl
} from './loader';
import { LoggedInUserStore } from '@agyletime/vue-3-common/src/plugins/loggedInUser';
import { FeatureFlowPlugin } from '@agyletime/vue-3-common/src/plugins/featureflow';
import { ACLPlugin } from '@agyletime/vue-3-common/src/plugins/acl';
import { TranslationsPlugin } from '@agyletime/vue-3-common/src/plugins/translations';
import { Pendo } from '@agyletime/vue-3-common/src/plugins/pendo';
import VueLogger from 'vuejs3-logger';
const app = createApp(App);
app.component(
    'NavBar',
    defineAsyncComponent(async () => {
    // TODO: Dev to get it from node_modules, non dev get it from CDN.
        const { NavBar } = await getDynamicImport('vue-3-common.es.js');
        return NavBar;
    })
);
app.component(
    'FilterBar',
    defineAsyncComponent(async () => {
    // TODO: Dev to get it from node_modules, non dev get it from CDN.
        const { FilterBar } = await getDynamicImport('vue-3-common.es.js');
        return FilterBar;
    })
);
app.component(
    'SidebarComponent',
    defineAsyncComponent(async () => {
    // TODO: Dev to get it from node_modules, non dev get it from CDN.
        const { SidebarComponent } = await getDynamicImport('vue-3-common.es.js');
        return SidebarComponent;
    })
);
app.use(VueLogger, loggingOptions);
app.use(router);
app.use(LoggedInUserStore);
app.use(FeatureFlowPlugin);
app.use(ACLPlugin);
app.use(TranslationsPlugin({}));
app.use(Pendo(import.meta.env.VITE_PENDO_API_KEY));
app.use(async () => {
    // Import the built css for the cdn components
    const hashmap = await getHashMap();
    const stylesheet = document.createElement('link');
    stylesheet.setAttribute('rel', 'stylesheet');
    stylesheet.setAttribute('type', 'text/css');
    stylesheet.setAttribute('href', `${stylesUrl}${hashmap['style.css']}`);
    document.head.appendChild(stylesheet);
});

app.mount('#app');
